<div class="modal-header">
  <h4 class="modal-title">{{ 'PAYZEN_REFUND_ERROR_TITLE' | translate }}</h4>
  <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="handleClick()">&times;</button>
</div>

<div class="modal-body">
  <p class="text-center">
    {{ 'PAYZEN_REFUND_ERROR_BODY' | translate }}
  </p>
  <p class="alert alert-warning text-center" *ngIf="errorCode || errorMessage">
    <span class="font-weight-500">{{ errorCode }}</span
    >&nbsp;{{ errorMessage }}
  </p>
  <div class="alert alert-info text-left">
    <mdb-icon size="lg" fas icon="info-circle" class="mr-1"></mdb-icon>
    <span>{{ 'ERROR.LINK_ADVICE' | translate }}</span
    >&nbsp;:&nbsp;
    <a href="https://payzen.io/fr-FR/rest/V4.0/api/errors_psp.html" target="_blank">{{ 'LABEL.CLICK_HERE' | translate }}</a>
  </div>
</div>

<div class="modal-footer">
  <jhi-bary-button (clickEvent)="handleClick()" [label]="'BTN.CONTINUE' | translate" color="primary"> </jhi-bary-button>
</div>
